import { ButtonPrimary, skinVars, SuccessFeedbackScreen, useWindowSize } from '@telefonica/mistica';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import './index.scss';

const FeedbackSimActivation = () => {
    const navigate = useNavigate();
    const size = useWindowSize();

    const naigateHome = () => {
        navigate(`/home`);
    };

    return (
        <div
            className='feedback-sim-activation'
            style={{ background: size.width < 1024 || size.height < 550 ? skinVars.colors.backgroundBrand : '' }}
        >
            <SuccessFeedbackScreen
                title={t('simActivationSuccessTitle')}
                description={t('simActivationSuccessDescription')}
                primaryButton={<ButtonPrimary onPress={naigateHome}>{t('calldivertalerttextbtn')}</ButtonPrimary>}
            />
        </div>
    );
};

export default FeedbackSimActivation;
